import type { AsyncDataRequestStatus } from '#app';

// wabunka-shared
export const useAsyncDataRequestStatus = (status: Ref<AsyncDataRequestStatus>) => {
  const hasSent = computed<boolean>(() => status.value !== 'idle');
  const isLoading = computed<boolean>(() => status.value === 'pending');
  const hasError = computed<boolean>(() => status.value === 'error');
  const hasSucceeded = computed<boolean>(() => status.value === 'success');

  return { hasSent, isLoading, hasError, hasSucceeded };
};
